// extracted by mini-css-extract-plugin
module.exports = {"exchangeExecutive":"styles_exchangeExecutive__2IuJj"};